import { render, staticRenderFns } from "./new-activity-form.vue?vue&type=template&id=57165a71&"
import script from "./new-activity-form.vue?vue&type=script&lang=js&"
export * from "./new-activity-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports